/**
 * @param {string} path
 * @returns {Boolean}
 */
export const isExternal = (path) => {
  return /^(https?:|mailto:|tel:)/.test(path);
};

/**
 * @param {string} str
 * @returns {Boolean}
 */
export const validUsername = (str) => {
  const valid_map = ["admin", "editor"];
  return valid_map.indexOf(str.trim()) >= 0;
};

/**
 * @param {string} url
 * @returns {Boolean}
 */
export const validURL = (url) => {
  const reg =
    /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(url);
};

/**
 * @param {string} str
 * @returns {Boolean}
 */
export const validLowerCase = (str) => {
  const reg = /^[a-z]+$/;
  return reg.test(str);
};

/**
 * @param {string} str
 * @returns {Boolean}
 */
export const validUpperCase = (str) => {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
};

/**
 * @param {string} str
 * @returns {Boolean}
 */
export const validAlphabets = (str) => {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
};

/**
 * @param {string} email
 * @returns {Boolean}
 */
export const validEmail = (email) => {
  const reg =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(email);
};

/**
 * @param {string} str
 * @returns {Boolean}
 */
export const isString = (str) => {
  if (typeof str === "string" || str instanceof String) {
    return true;
  }
  return false;
};

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export const isArray = (arg) => {
  if (typeof Array.isArray === "undefined") {
    return Object.prototype.toString.call(arg) === "[object Array]";
  }
  return Array.isArray(arg);
};

/**
 * 验证手机格式
 */
export const mobile = (value) => {
  return /^1[3456789]\d{9}$/.test(value);
};

/**
 * 验证URL格式
 */
export const url = (value) => {
  return /^((https|http|ftp|rtsp|mms):\/\/)(([0-9a-zA-Z_!~*'().&=+$%-]+: )?[0-9a-zA-Z_!~*'().&=+$%-]+@)?(([0-9]{1,3}.){3}[0-9]{1,3}|([0-9a-zA-Z_!~*'()-]+.)*([0-9a-zA-Z][0-9a-zA-Z-]{0,61})?[0-9a-zA-Z].[a-zA-Z]{2,6})(:[0-9]{1,4})?((\/?)|(\/[0-9a-zA-Z_!~*'().;?:@&=+$,%#-]+)+\/?)$/.test(
    value
  );
};

/**
 * 验证日期格式
 */
export const date = (value) => {
  if (!value) return false;
  // 判断是否数值或者字符串数值(意味着为时间戳)，转为数值，否则new Date无法识别字符串时间戳
  if (number(value)) value = +value;
  return !/Invalid|NaN/.test(new Date(value).toString());
};

/**
 * 验证ISO类型的日期格式
 */
export const dateISO = (value) => {
  return /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test(
    value
  );
};

/**
 * 验证十进制数字
 */
export const number = (value) => {
  return /^[\+-]?(\d+\.?\d*|\.\d+|\d\.\d+e\+\d+)$/.test(value);
};

/**
 * 验证字符串
 */
export const string = (value) => {
  return typeof value === "string";
};

/**
 * 验证整数
 */
export const digits = (value) => {
  return /^\d+$/.test(value);
};

/**
 * 验证身份证号码
 */
export const idCard = (value) => {
  return /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(
    value
  );
};

/**
 * 是否车牌号
 */
export const carNo = (value) => {
  // 新能源车牌
  const xreg =
    /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
  // 旧车牌
  const creg =
    /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
  if (value.length === 7) {
    return creg.test(value);
  }
  if (value.length === 8) {
    return xreg.test(value);
  }
  return false;
};

/**
 * 金额,只允许2位小数
 */
export const amount = (value) => {
  // 金额，只允许保留两位小数
  return /^[1-9]\d*(,\d{3})*(\.\d{1,2})?$|^0\.\d{1,2}$/.test(value);
};

/**
 * 中文
 */
export const chinese = (value) => {
  const reg = /^[\u4e00-\u9fa5]+$/gi;
  return reg.test(value);
};

/**
 * 只能输入字母
 */
export const letter = (value) => {
  return /^[a-zA-Z]*$/.test(value);
};

/**
 * 只能是字母或者数字
 */
export const enOrNum = (value) => {
  // 英文或者数字
  const reg = /^[0-9a-zA-Z]*$/g;
  return reg.test(value);
};

/**
 * 验证是否包含某个值
 */
export const contains = (value, param) => {
  return value.indexOf(param) >= 0;
};

/**
 * 验证一个值范围[min, max]
 */
export const range = (value, param) => {
  return value >= param[0] && value <= param[1];
};

/**
 * 验证一个长度范围[min, max]
 */
export const rangeLength = (value, param) => {
  return value.length >= param[0] && value.length <= param[1];
};

/**
 * 是否固定电话
 */
export const landline = (value) => {
  const reg = /^\d{3,4}-\d{7,8}(-\d{3,4})?$/;
  return reg.test(value);
};

/**
 * 判断是否为空
 */
export const empty = (value) => {
  switch (typeof value) {
    case "undefined":
      return true;
    case "string":
      if (value.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, "").length == 0)
        return true;
      break;
    case "boolean":
      if (!value) return true;
      break;
    case "number":
      if (value === 0 || isNaN(value)) return true;
      break;
    case "object":
      if (value === null || value.length === 0) return true;
      for (const i in value) {
        return false;
      }
      return true;
  }
  return false;
};

/**
 * 是否json字符串
 */
export const jsonString = (value) => {
  if (typeof value === "string") {
    try {
      const obj = JSON.parse(value);
      if (typeof obj === "object" && obj) {
        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }
  return false;
};

/**
 * 是否数组
 */
export const array = (value) => {
  if (typeof Array.isArray === "function") {
    return Array.isArray(value);
  }
  return Object.prototype.toString.call(value) === "[object Array]";
};

/**
 * 是否对象
 */
export const object = (value) => {
  return Object.prototype.toString.call(value) === "[object Object]";
};

/**
 * 是否短信验证码
 */
export const code = (value, len = 6) => {
  return new RegExp(`^\\d{${len}}$`).test(value);
};

/**
 * 是否函数方法
 * @param {Object} value
 */
export const func = (value) => {
  return typeof value === "function";
};

/**
 * 是否promise对象
 * @param {Object} value
 */
export const promise = (value) => {
  return object(value) && func(value.then) && func(value.catch);
};

/** 是否图片格式
 * @param {Object} value
 */
export const image = (value) => {
  const IMAGE_REGEXP = /\.(jpeg|jpg|gif|png|svg|webp|jfif|bmp|dpg)/i;
  return IMAGE_REGEXP.test(value);
};

/**
 * 是否视频格式
 * @param {Object} value
 */
export const video = (value) => {
  const VIDEO_REGEXP = /\.(mp4|mpg|mpeg|dat|asf|avi|rm|rmvb|mov|wmv|flv|mkv)/i;
  return VIDEO_REGEXP.test(value);
};

/**
 * 是否为正则对象
 * @param {Object}
 * @return {Boolean}
 */
export const regExp = (o) => {
  return o && Object.prototype.toString.call(o) === "[object RegExp]";
};

//校验码
const checkCode = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
//系数
const coefficient = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
//省份编码
const areaCode = new Set();
areaCode.add(11); //北京市
areaCode.add(12); //天津市
areaCode.add(13); //河北省
areaCode.add(14); //山西省
areaCode.add(15); //内蒙古自治区
areaCode.add(21); //辽宁省
areaCode.add(22); //吉林省
areaCode.add(23); //黑龙江省
areaCode.add(31); //上海市
areaCode.add(32); //江苏省
areaCode.add(33); //浙江省
areaCode.add(34); //安徽省
areaCode.add(35); //福建省
areaCode.add(36); //江西省
areaCode.add(37); //山东省
areaCode.add(41); //河南省
areaCode.add(42); //湖北省
areaCode.add(43); //湖南省
areaCode.add(44); //广东省
areaCode.add(45); //广西壮族自治区
areaCode.add(46); //海南省
areaCode.add(50); //重庆市
areaCode.add(51); //四川省
areaCode.add(52); //贵州省
areaCode.add(53); //云南省
areaCode.add(54); //西藏自治区
areaCode.add(61); //陕西省
areaCode.add(62); //甘肃省
areaCode.add(63); //青海省
areaCode.add(64); //宁夏回族自治区
areaCode.add(65); //新疆维吾尔自治区
areaCode.add(71); //台湾省
areaCode.add(81); //香港特别行政区
areaCode.add(82); //澳门特别行政区

/**
 * 校验身份证号
 * @param idCard 身份证号
 * @returns {boolean} true-校验通过 false-校验不通过
 */
function validateIdentityCard(idCard) {
  let idCardClone = idCard;
  if (idCardClone) {
    idCardClone = String(idCardClone);
  }

  if (!idCardClone || idCardClone.length !== 18) {
    return false;
  }

  return (
    validateCheckCode(idCardClone) &&
    validateAreaCode(idCardClone) &&
    validateDate(idCardClone)
  );
}

/**
 * 校验校验码
 * @param idCard 身份证号
 * @returns {boolean} true-校验通过 false-校验不通过
 */
function validateCheckCode(idCard) {
  let sum = 0;
  for (let i = 0; i < coefficient.length; i++) {
    let charCode = idCard.charCodeAt(i);
    if (charCode >= 48 && charCode <= 57) {
      sum += coefficient[i] * (charCode - 48);
    } else {
      return false;
    }
  }

  return checkCode[sum % 11] === idCard.charAt(17);
}

/**
 * 校验前两位省份编码
 * @param idCard 身份证号
 * @returns {boolean} true-校验通过 false-校验不通过
 */
function validateAreaCode(idCard) {
  return areaCode.has(parseInt(idCard.substring(0, 2), 10));
}

/**
 * 校验6-14位的出生日期
 * @param idCard 身份证号
 * @returns {boolean} true-校验通过 false-校验不通过
 */
function validateDate(idCard) {
  let dateStr = idCard.substring(6, 14);
  return !isNaN(
    Date.parse(
      dateStr.substring(0, 4) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(6, 8)
    )
  );
}

// 身份证号验证
export const idCardValidate = async (rule, value) => {
  if (validateIdentityCard(value)) {
    return Promise.resolve();
  } else {
    if (!rule.required) {
      if (value == "" || value == null) {
        return Promise.resolve();
      } else {
        return Promise.reject("请输入正确格式的身份证号码");
      }
    } else {
      if (value == "" || value == null) {
        return Promise.reject("请输入身份证号码");
      } else {
        return Promise.reject("请输入正确格式的身份证号码");
      }
    }
  }
};

export default {
  validEmail,
  mobile,
  url,
  date,
  dateISO,
  number,
  digits,
  idCard,
  carNo,
  amount,
  chinese,
  letter,
  enOrNum,
  contains,
  range,
  rangeLength,
  empty,
  isEmpty: empty,
  jsonString,
  landline,
  object,
  array,
  code,
  func,
  promise,
  video,
  image,
  regExp,
  string,
  idCardValidate,
};
